import React from "react";

import { Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Blog from "./Blog";

const BlogDashboard = () => {
  document.title = "Dashboard | Upzet - React Admin & BlogDashboard Template";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Upzet" breadcrumbItem="Blog Dashboard" />
          <Blog />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BlogDashboard;
